<template>
  <div class="providers">
    <div class="search">
      <el-autocomplete
        v-model="search"
        :fetch-suggestions="querySearchAsync"
        :trigger-on-focus="false"
        :placeholder="$t('providers.search')"
        @select="handleSelect"
      >
        <svg-icon slot="prefix" name="search" />
        <svg-icon v-if="search.length" slot="suffix" name="close" @click="resetSelect" />
      </el-autocomplete>
    </div>

    <div class="scrollbar">
      <div
        v-for="provider in providers"
        :key="provider.id"
        :class="{'selected': selected && provider.id === selected.id}"
        class="provider"
        @click="selectProvider(provider)"
      >
        <el-row>
          <el-col :span="2" class="avatar">
            <el-avatar icon="el-icon-user-solid" :src="provider.profile.avatar | avatar64" />
          </el-col>
          <el-col :span="13">
            <span class="name" v-text="provider.profile.name" />
            <span class="email" v-text="provider.email" />
          </el-col>
          <el-col :span="5" class="date">
            <span>
              {{ $t('providers.signed') }}: {{ provider.created_at }}
            </span>
            <div class="views">
              Views:
              <span>{{ provider.profile.visits_count ? provider.profile.visits_count : 0 }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <ts-pagination
      :total="total"
      :page-size="10"
      @current-change="changePage"
    />
  </div>
</template>

<script>
  import { getProviders } from '@/api/providers'
  import Pagination from '@/components/Pagination.vue'

  export default {
    components: {
      'ts-pagination': Pagination
    },

    props: {
      selected: Object
    },

    data() {
      return {
        page: 1,
        search: ''
      }
    },

    computed: {
      providers() {
        return this.$store.state.Providers.list
      },

      total() {
        return this.$store.state.Providers.total
      }
    },

    created() {
      this.getList()
    },

    methods: {
      getList() {
        this.$store.dispatch('Providers/getProviders', {
          page: this.page,
          query: this.search
        })
      },

      changePage(page) {
        this.page = page
        this.getList()
      },

      selectProvider(provider) {
        this.$emit('provider-change', provider)
      },

      getHunterName(provider) {
        return provider.profile.hunter
          ? provider.profile.hunter.profile.name
          : ''
      },

      getAvatar(provider) {
        return provider.profile.avatar
          ? provider.profile.avatar.thumb_64
          : ''
      },

      async querySearchAsync(queryString, cb) {
        const { data } = await getProviders({
          page: 1,
          query: queryString
        })

        const list = data.data.map(item => {
          return {
            value: item.profile.name
          }
        })

        cb(list)
      },

      resetSelect() {
        this.search = ''
        this.$store.dispatch('Providers/getProviders', {
          page: 1,
          query: ''
        })
      },

      handleSelect(item) {
        this.$store.dispatch('Providers/getProviders', {
          page: 1,
          query: item.value
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .providers {
    position: absolute;
    top: 30px;
    right: 15px;
    bottom: 30px;
    left: 0;
    z-index: 500;

    .scrollbar {
      height: 80%;
    }

    .search {
      margin-bottom: 20px;
    }

    .provider {
      border-bottom: 1px solid $border-color-light;
      padding: 20px 0;
      cursor: pointer;

      .avatar {
        min-width: 60px;
        padding-top: 5px;
        color: white;
        border: 2px solid white;
      }

      .name {
        display: block;
        font-weight: 500;
        font-size: 20px;
        line-height: 30px;
        color: $color-text-regular;
      }

      .email {
        font-size: 13px;
        line-height: 24px;
        color: $color-text-placeholder;
      }

      .date {
        display: block;
        float: right;
        text-align: right;
        font-size: 12px;
        line-height: 18px;
        padding-top: 15px;
        color: $color-text-placeholder;
      }

      .views {
        font-size: 13px;
        color: $color-text-secondary;

        span {
          font-weight: 500;
          font-size: 13px;
        }
      }

      &.selected {
        .avatar {
          .el-avatar {
            border: 2px solid $color-primary;
          }
        }

        .name, .hunter {
          color: $color-primary
        }
      }
    }
  }
</style>
